var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
//shamelessly stolen from: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/samples/react-sample-app/src/auth-utils.js
import { UserAgentApplication } from 'msal';
function isIE() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ') > -1;
    const msie11 = ua.indexOf('Trident/') > -1;
    // If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
    // const isEdge = ua.indexOf("Edge/") > -1;
    return msie || msie11;
}
const getClientId = (() => {
    let _clientId;
    return () => __awaiter(void 0, void 0, void 0, function* () {
        if (!_clientId) {
            const response = yield fetch('/api-config');
            const { msClientId } = yield response.json();
            _clientId = msClientId;
        }
        return _clientId;
    });
})();
export const getMsalApp = () => __awaiter(void 0, void 0, void 0, function* () {
    const msClientId = yield getClientId();
    return new UserAgentApplication({
        auth: {
            clientId: msClientId,
            authority: 'https://login.microsoftonline.com/common',
            validateAuthority: true,
            postLogoutRedirectUri: 'http://localhost:3000',
            navigateToLoginRequestUrl: false
        },
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: isIE()
        },
        system: {
            navigateFrameWait: 0
        }
    });
});
